import * as React from "react";
import { Navbar, NavbarToggle } from "flowbite-react";


const HeaderMinimal: React.FC<{ fixed: Boolean, onClose?: () => void }> = ({ fixed, onClose }) => {
  return (
    <Navbar
      fluid
      rounded
      className={`container display rounded-none border-b-1 border-primary ${
        fixed ? 'sticky top-0 z-40 bg-white' : ''
      }`}
    >
      <a href ="/">
        <span className="self-center whitespace-nowrap text-xl">
          <span className="text-gray-600">Mind</span>
          <span className="font-semibold text-primary">Pulse</span>
        </span>
      </a>
      <div className="flex md:order-2">
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center p-2 text-lg font-medium text-green-800 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500 cursor-pointer"
          aria-label="Close"
        >
          <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </Navbar>
  );
};

export default HeaderMinimal;
